import { Cart, RetailerInfoType } from './types';
import { atom } from 'jotai';
import mixpanel from 'mixpanel-browser';
import { env } from '@/env';
import { Address, Article, OrderDeliveryInput } from '@/types';
import { atomWithStorage } from 'jotai/utils';

interface LocalUser {
  id: string;
  givenName: string;
  familyName: string;
  phoneNumber: string;
  primaryAddress: Omit<Address, 'owner' | 'ownerId' | 'coordinates'>;
  addresses: Omit<Address, 'owner' | 'ownerId'>[];
}

// user related atoms
export const userAtom = atom<LocalUser | null>(null);
export const isUserRetreivedAtom = atom<boolean>(false);

// inventory related atoms
export const RateilerPageDetails = atom<RetailerInfoType | null>(null);
export const isInventoryListAtom = atom<boolean>(false);
export const isInventoryAscending = atom<boolean>(false);
export const isReroderWarningEnabled = atom<boolean>(false);

// cart related atoms
export const isCartOpenAtom = atom<boolean>(false);
export const cartAtom = atomWithStorage<Cart>('cart', {});

export const getRetailerCartAtom = atom((get) => {
  const cart: Cart | object = get(cartAtom);

  return (retailerID: string): OrderDeliveryInput[] | [] =>
    cart ? cart[retailerID] : [];
});

export const newCartItemAtom = atom<Article | null>(null);
//

interface CheckoutDeliveryShipment extends OrderDeliveryInput {
  shipmentId: number;
  selectedAddressId: number | null;
}

export const checkoutDeliveriesAtom = atom<CheckoutDeliveryShipment[] | []>([]);
//

export const logoutAtom = atom(null, (get, set) => {
  if (env.VITE_MIXPANEL_TOKEN) {
    mixpanel.reset();
  }
  set(userAtom, null);
  set(isUserRetreivedAtom, false);
});

export const selectedMainTaxonomyAtom = atom<number>(1);
export const selectedChildTaxonomyAtom = atom<number | null>(null);

// export const cartTaxAmountAtom = atom((get) => {
//   const cart = get(cartAtom);
//   if (!cart) return 0;

//   const orderTax = cart.reduce((a, d) => {
//     return (
//       (d.cartQuantity as number) *
//         (d.price as number) *
//         ((d.taxRate as number) / 100) +
//       a
//     );
//   }, 0);

//   return orderTax;
// });
